import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useHttpClient } from '../../../shared/http-client';
import { formatDateTime, classNames } from '../../../utils';


export const AsignacionesEdit = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { api, state } = useHttpClient();
    const { id } = useParams();
    const [data, setData] = useState<any | null>(null);


    useEffect(() => {
        if (id) {
            api(`/fleet/assignments/${id}/`, 'GET');
        }
    }, [id]);



    useEffect(() => {
        if (state.data) {
            if (state.path.includes('assignments')) {
                setData(state.data);
            }
        }

        if (state.error) {
            toast.error('Server Error');
        }
    }, [state]);

    const LabelValue = ({ label, value }: { label: string; value: any }) => (
        <div className="flex gap-2 text-[15px]">
            <span className="font-medium text-gray-500">{label}:</span>
            <span className="font-semibold text-gray-900">{value || "--"}</span>
        </div>
    );

    const Section = ({
        title,
        children,
    }: {
        title: string;
        children: React.ReactNode;
    }) => (
        <div className="bg-white shadow rounded-xl p-4">
            <h3 className="text-gray-700 font-semibold text-lg mb-3">{title}</h3>
            {children}
        </div>
    );

    const PhotosGroup = ({
        title,
        items,
    }: {
        title: string;
        items: { label: string; url?: string }[];
    }) => {
        const validItems = items.filter((i) => i.url);
        if (!validItems.length) return null;

        return (
            <div className="bg-white shadow rounded-xl p-5">
                <h3 className="text-gray-700 font-semibold text-lg mb-4">{title}</h3>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
                    {validItems.map((item, i) => (
                        <div key={i} className="text-center text-sm text-gray-700">
                            <span className="font-semibold block mb-2">{item.label}</span>
                            <img
                                src={item.url}
                                className="w-full h-32 object-cover rounded-lg shadow cursor-pointer hover:scale-[1.05] transition"
                                onClick={() => window.open(item.url!, "_blank")}
                                alt={item.label}
                            />
                        </div>
                    ))}
                </div>
            </div>
        );
    };


    return (
        <div className='py-4 px-8 w-full'>
            <div
                className="pb-4 cursor-pointer"
                onClick={() => navigate(-1)}
            >
                <span className='text-black pt-[5px]'>{'< '}</span>
                <span className='text-black text-[12px]'>{t('common.button.back')}</span>
            </div>
            <div className='flex'>
                {/* <div className='flex'>
                    {data?.driver?.photo_display_url ? <img className='h-[180px] pb-4 pr-4' src={data?.driver?.photo_display_url} /> : ''}
                    {data?.vehicle?.photo_display_url ? <img className='h-[180px] pb-4 pr-4' src={data?.vehicle?.photo_display_url} /> : ''}
                </div> */}
                {/* <div className='pl-8'>
                    <div className='flex'>
                        <div className="text-[20px]  text-gray-900 pr-4">
                            {t('common.label.asignacion')}:
                        </div>
                        <div className="text-[20px]  text-gray-900 pr-4 font-semibold">
                            {data?.code}
                        </div>
                    </div>
                    <div className='flex'>
                        <div className="text-[20px]  text-gray-900 pr-4">
                            {t('common.label.vehiculo')}:
                        </div>
                        <div className="text-[20px]  text-gray-900 pr-4 font-semibold">
                            {data?.vehicle?.plate}
                        </div>
                    </div>
                    <div className='flex'>
                        <div className="text-[20px]  text-gray-900 pr-4">
                            {t('common.label.conductor')}:
                        </div>
                        <div className="text-[20px]  text-gray-900 pr-4 font-semibold">
                            {data?.driver?.full_name}
                        </div>
                    </div>
                    <div className='flex text-[20px]'>
                        <span>{t('common.label.fecha-hora-asignacion')}:</span>
                        <span className='pl-2 font-semibold'>{data?.assignment_datetime && formatDateTime(data?.assignment_datetime)}</span>
                    </div>
                    <div className='flex text-[20px]'>
                        <span>{t('common.label.fecha-hora-finalizacion')}:</span>
                        <span className='pl-2 font-semibold'>{data?.completion_datetime && formatDateTime(data?.completion_datetime)}</span>
                    </div>

                </div> */}
            </div>
            {/* <div>
                <div className='flex space-x-8 pt-4'>
                    {data?.assignment_signature_display_url ? <div>
                        <span className='block text-md font-semibold leading-6 text-gray-700'>{t('common.label.firma-asignacion')}</span>
                        <img className='h-[280px] pb-4 pr-4' src={data?.assignment_signature_display_url} />
                    </div> : ''}
                    {data?.release_signature_display_url ? <div>
                        <span className='block text-md font-semibold leading-6 text-gray-700'>{t('common.label.firma-devolucion')}</span>
                        <img className='h-[280px] pb-4 pr-4' src={data?.release_signature_display_url} />
                    </div> : ''}
                </div>
            </div> */}
            {/* <div className='pb-8'>
                <div className='flex space-x-8 pt-4 w-full justify-between'>
                    {data?.front_photo_before_display_url ? <div>
                        <span className='block text-md font-semibold leading-6 text-gray-700'>{t('common.label.foto-antes-delante')}</span>
                        <img className='w-[220px] pb-4 pr-4 cursor-pointer' onClick={() => window.open(data?.front_photo_before_display_url, '_blank', 'noreferrer')} src={data?.front_photo_before_display_url}  />
                    </div> : ''}
                    {data?.back_photo_before_display_url ? <div>
                        <span className='block text-md font-semibold leading-6 text-gray-700'>{t('common.label.foto-antes-detras')}</span>
                        <img className='w-[220px] pb-4 pr-4 cursor-pointer' onClick={() => window.open(data?.back_photo_before_display_url, '_blank', 'noreferrer')} src={data?.back_photo_before_display_url}  />
                    </div> : ''}
                    {data?.left_photo_before_display_url ? <div>
                        <span className='block text-md font-semibold leading-6 text-gray-700'>{t('common.label.foto-antes-izquierda')}</span>
                        <img className='w-[220px] pb-4 pr-4 cursor-pointer' onClick={() => window.open(data?.left_photo_before_display_url, '_blank', 'noreferrer')} src={data?.left_photo_before_display_url}  />
                    </div> : ''}
                    {data?.right_photo_before_display_url ? <div>
                        <span className='block text-md font-semibold leading-6 text-gray-700'>{t('common.label.foto-antes-derecha')}</span>
                        <img className='w-[220px] pb-4 pr-4 cursor-pointer' onClick={() => window.open(data?.right_photo_before_display_url, '_blank', 'noreferrer')} src={data?.right_photo_before_display_url}  />
                    </div> : ''}
                </div>
            </div> */}
           {/*  <div className='pb-8'>
                <div className='flex space-x-8 pt-4 w-full justify-between'>
                    {data?.front_photo_after_display_url ? <div>
                        <span className='block text-md font-semibold leading-6 text-gray-700'>{t('common.label.foto-despues-delante')}</span>
                        <img className='w-[220px] pb-4 pr-4 cursor-pointer' onClick={() => window.open(data?.front_photo_after_display_url, '_blank', 'noreferrer')} src={data?.front_photo_after_display_url}  />
                    </div> : ''}
                    {data?.back_photo_after_display_url ? <div>
                        <span className='block text-md font-semibold leading-6 text-gray-700'>{t('common.label.foto-despues-detras')}</span>
                        <img className='w-[220px] pb-4 pr-4 cursor-pointer' onClick={() => window.open(data?.back_photo_after_display_url, '_blank', 'noreferrer')} src={data?.back_photo_after_display_url}  />
                    </div> : ''}
                    {data?.left_photo_after_display_url ? <div>
                        <span className='block text-md font-semibold leading-6 text-gray-700'>{t('common.label.foto-despues-izquierda')}</span>
                        <img className='w-[220px] pb-4 pr-4 cursor-pointer' onClick={() => window.open(data?.left_photo_after_display_url, '_blank', 'noreferrer')} src={data?.left_photo_after_display_url}  />
                    </div> : ''}
                    {data?.right_photo_after_display_url ? <div>
                        <span className='block text-md font-semibold leading-6 text-gray-700'>{t('common.label.foto-despues-derecha')}</span>
                        <img className='w-[220px] pb-4 pr-4 cursor-pointer' onClick={() => window.open(data?.right_photo_after_display_url, '_blank', 'noreferrer')} src={data?.right_photo_after_display_url}  />
                    </div> : ''}
                </div>
            </div> */}
            <div className="mt-10 space-y-10">

                {/* Header Info */}
                <div className="flex gap-6 items-start bg-white shadow rounded-xl p-6">
                    {/* Images Driver + Vehicle */}
                    <div className="flex gap-4">
                        {data?.driver?.photo_display_url && (
                            <img
                                src={data.driver.photo_display_url}
                                className="w-32 h-32 object-cover rounded-lg shadow"
                                alt="Driver"
                            />
                        )}
                        {data?.vehicle?.photo_display_url && (
                            <img
                                src={data.vehicle.photo_display_url}
                                className="w-auto h-32 object-cover rounded-lg shadow"
                                alt="Vehicle"
                            />
                        )}
                    </div>

                    {/* Assignment Info */}
                    <div className=" gap-y-3 text-gray-700 text-lg  pl-4">
                        <LabelValue label={t('common.label.asignacion')} value={data?.code} />
                        <LabelValue label={t('common.label.vehiculo')} value={data?.vehicle?.plate} />
                        <LabelValue label={t('common.label.conductor')} value={data?.driver?.full_name} />
                        <LabelValue
                            label={t('common.label.fecha-hora-asignacion')}
                            value={data?.assignment_datetime && formatDateTime(data?.assignment_datetime)}
                        />
                        <LabelValue
                            label={t('common.label.fecha-hora-finalizacion')}
                            value={data?.completion_datetime && formatDateTime(data?.completion_datetime)}
                        />
                    </div>
                </div>

                {/* Signatures */}
                {data?.assignment_signature_display_url ? <Section title={t('common.label.firma-asignacion')}>
                    {data?.assignment_signature_display_url && (
                        <img
                            src={data.assignment_signature_display_url}
                            className="h-40 rounded-lg shadow cursor-pointer hover:scale-[1.05] transition"
                            onClick={() => window.open(data.assignment_signature_display_url, '_blank')}
                            alt="Asignación"
                        />
                    )}
                </Section> : ''}

                {data?.release_signature_display_url ? <Section title={t('common.label.firma-devolucion')}>
                    {data?.release_signature_display_url && (
                        <img
                            src={data.release_signature_display_url}
                            className="h-40 rounded-lg shadow cursor-pointer hover:scale-[1.05] transition"
                            onClick={() => window.open(data.release_signature_display_url, '_blank')}
                            alt="Devolución"
                        />
                    )}
                </Section> : ''}

                {/* Before Vehicle Photos */}
                <PhotosGroup
                    title={t('common.label.fotos-antes')}
                    items={[
                        { label: t('common.label.foto-antes-delante'), url: data?.front_photo_before_display_url },
                        { label: t('common.label.foto-antes-detras'), url: data?.back_photo_before_display_url },
                        { label: t('common.label.foto-antes-izquierda'), url: data?.left_photo_before_display_url },
                        { label: t('common.label.foto-antes-derecha'), url: data?.right_photo_before_display_url },
                    ]}
                />

                {/* After Vehicle Photos */}
                <PhotosGroup
                    title={t('common.label.fotos-despues')}
                    items={[
                        { label: t('common.label.foto-despues-delante'), url: data?.front_photo_after_display_url },
                        { label: t('common.label.foto-despues-detras'), url: data?.back_photo_after_display_url },
                        { label: t('common.label.foto-despues-izquierda'), url: data?.left_photo_after_display_url },
                        { label: t('common.label.foto-despues-derecha'), url: data?.right_photo_after_display_url },
                    ]}
                />

            </div>

        </div>
    );
};